import { graphql } from "react-relay";

// components
import "./Event.gql";
import "@components/pain-or-priority-event/PainOrPriorityEvent.gql";

/**
 * TODO: multi-org support
 */
export const eventRendererQuery = graphql`
  query EventRendererQuery(
    $orgRelayId: ID!
    $externalEventId: String!
    $externalEventIds: [String!]!
    $calendarId: String!
    $calendarIds: [String!]!
    $isLinkedSmartHold: Boolean!
    $isOnAPHistory: Boolean!
  ) {
    org: node(id: $orgRelayId) {
      __typename
      id

      ... on Org {
        name
        domains
        ...Event_org
        ...PainOrPriorityEvent_org
        canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $calendarIds) {
          __typename
          ... on CanScheduleResponseList {
            list {
              canAutopilot
              canReschedule
              attendeeNotInDomain
              organizerNotClockwiseUser
              isAllDayEvent
            }
          }
        }
        crawledCalendarInfoForCalendars(calendarIds: $calendarIds) {
          none
          pending
          synced
          stale
        }
        smartHoldEventInfo(externalEventId: $externalEventId) @include(if: $isLinkedSmartHold) {
          __typename
          ... on SmartHoldEventInfo {
            ...Event_smartHoldEventInfo
          }
        }
        shadowCalendarSettingsErrorable {
          __typename
          ... on ShadowCalendarSettings {
            enabled
            shadowCalendarId
          }
        }
        forceFetchEventParentErrorable(calendarId: $calendarId, externalEventId: $externalEventId) {
          __typename

          ... on GraphEntityError {
            statusCode
          }

          ... on EventParent {
            id
            ...Event_eventParent @arguments(calendarId: $calendarId, isOnAPHistory: $isOnAPHistory)
            events {
              eventKey {
                externalEventId
              }
              calendarIds
              annotatedEvent {
                orgTags {
                  state {
                    value
                    active
                  }
                }
              }
            }
          }
        }
      }
    }
    viewer {
      user {
        ...Event_user
      }
    }
  }
`;
